import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles<string, { isExpandable: boolean }>(
  {
    root: {
      width: 'auto',
      maxWidth: '100%',
    },
    title: {
      color: 'var(--x-black)',
      fontSize: 14,
      marginBottom: 16,
      textTransform: 'uppercase',
    },
    content: {
      listStyleType: 'none',
      display: 'flex',
      flexWrap: 'wrap',
    },
    expandable: {
      flexDirection: 'column',
      gap: 4,
      backgroundColor: 'var(--x-bg-5)',
      borderRadius: 12,
    },
    nonExpandable: {
      flexDirection: 'row',
      backgroundColor: 'var(--x-bg-1)',
      borderRadius: 'none',
    },
    item: {
      alignItems: 'center',
      color: 'var(--x-breadcrumb-last)',
      display: 'flex',
      fontSize: 14,
      lineHeight: '20px',
      minWidth: 'max-content',
    },
    link: {
      alignItems: 'center',
      display: 'flex',
      color: 'var(--x-breadcrumb-last)',
      justifyContent: 'space-between',
      margin: ({ isExpandable }) => (isExpandable ? '14px 0 14px 0' : '0px 16px 8px 0'),
      paddingInline: ({ isExpandable }) => (isExpandable ? 16 : 0),
      width: '100%',
      height: '100%',

      '&:hover': {
        color: 'var(--x-black-1)',
      },
    },
    text: {
      verticalAlign: 'middle',
    },
    new: {
      marginInlineStart: 4,
    },
  },
  {
    name: 'LinkBatch',
  },
);

export default useStyles;
